<ideal-product-section
  i18n-title="@@products.complimentary.label"
  title="Complimentary Products"
  navAnchorId="app.main-menu/products/details/complimentary"
  navAnchorHeading="Product"
  i18n-navAnchorHeading="@@products.nav.product.heading"
  [navAnchorHidden]="hasContent() === false"
  class="no-bg"
>
  <ideal-product-complimentary #content [productId]="id()"></ideal-product-complimentary>
</ideal-product-section>
